import { Component, HostListener, OnInit } from '@angular/core';
import { GuardsCheckEnd, GuardsCheckStart, NavigationCancel, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './core/services/local-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    if (environment.production) {
      event.preventDefault();
    }
  }
  isLoading: boolean;
  constructor(
    private readonly _router: Router,
    private readonly _localStorageService: LocalStorageService,
  ) {
    if (!this._localStorageService.machineId) {
      this._localStorageService.machineId = crypto.randomUUID();
    }
  }
  ngOnInit() {
    this._router.events.subscribe(event => {
      if (event instanceof GuardsCheckStart) {
        this.isLoading = true;
      }
      if (event instanceof GuardsCheckEnd || event instanceof NavigationCancel) {
        this.isLoading = false;
      }
    });
  }
}
